/**
 * @description 返回子模块有权限的路由
 * @param {String} modName 模块名
 */
import _ from 'lodash'
import { ElMessage } from 'element-plus'
import { getInitResources } from '@/utils/auth'
import store from '@/store'
import { NTPChannelDic as WaybillChannelDict } from '@/views/transport/entity/dict'

const ROUTERLIMIT = 3
const MENURESOURCE = 1

// 页面路径验证
function validateRoute(url) {
    const pathArr = _.chain(url).trim().trimStart('/').split('/').value()
    if (pathArr.length !== ROUTERLIMIT) return []
    if (_.lowerCase(pathArr[0]) !== 'mod') return []
    return pathArr
}
// 根据用户权限生成相应的模块路由表
function genrateModRouterMap(menus, result = {}) {
    _.reduce(
        menus,
        (routerMap, menu) => {
            const frontUrl = _.get(menu, 'frontUrl', '')
            if (frontUrl && frontUrl !== '/') {
                const arr = validateRoute(frontUrl)
                if (arr.length) {
                    const modName = _.camelCase(arr[1])
                    const routeName = _.camelCase(arr[2])
                    routerMap[modName] = _.isArray(routerMap[modName]) ? routerMap[modName] : []
                    routerMap[modName].push({
                        name: routeName,
                        path: frontUrl,
                    })
                } else {
                    // ElMessage.error('菜单路径不正确');
                }
            } else if (menu.resourceType === MENURESOURCE && _.get(menu, 'subResources', []).length > 0) {
                genrateModRouterMap(menu.subResources, routerMap)
            }
            return routerMap
        },
        result,
    )
    return result
}

export function filterMenus(menus) {
    const plantChannel = store.getters.plantChannel

    // console.log('plantChannel', plantChannel)

    return menus.reduce((acc, menu) => {
        // 仅货主配置网货渠道为G7时， 显示  客户端-左栏增加“渠道申请开票”菜单
        if (!WaybillChannelDict.isG7(plantChannel) && (menu.extendAttr1 || '').includes('channel-invoice-apply')) {
            return acc
        }

        if (menu.subResources) {
            return acc.concat({
                ...menu,
                subResources: filterMenus(menu.subResources),
            })
        }

        return acc.concat(menu)
    }, [])
}

const getRoutes = () => {
    const menus = JSON.parse(getInitResources())
    const routerMap = genrateModRouterMap(menus)
    return new Promise(resolve => {
        resolve(routerMap)
    })
}

/**
 * @description 分离模块名
 * @param {String} path 路由路径
 */
const splitModName = path => {
    // 本例中路由规定为 /mod/{modName} ,如 /mod/a/xxx 对应模块名为 a
    if (/\/mod\/(\w+)/.test(path)) {
        return RegExp.$1
    }
    return ''
}

/**
 * @description 取得模块有权限的路由 + 模块路由和组件映射关系 = 需要动态添加的路由
 * @param {String} modName 模块名
 */
const generateRoutes = (modName, routerMap) => {
    return getRoutes().then(data => {
        const modules = Object.keys(data)
        const routes = routerMap.filter(k => modules.includes(k.name))
        routes.forEach(k => {
            const moduleMenu = data[k.name]
            const moduleMenuNames = moduleMenu.map(k => k.name)
            k.children.filter(item => moduleMenuNames.includes(item.name))
        })

        return routes
    })
}
export { splitModName, generateRoutes }
